import React, { useEffect, useRef } from 'react';
import './qualification.css';
import Data from './Data';
import { BsBriefcaseFill } from 'react-icons/bs';

const Qualification = () => {
  // 1. Veriyi filtrele
  const experienceData = Data.filter(val => val.category === "experience");
  
  // 2. Filtrelenmiş diziyi ters çevirerek en yeniyi en başa al
  // Orijinal diziyi bozmamak için kopyasını oluşturup ters çeviriyoruz [...dizi]
  const sortedExperienceData = [...experienceData].reverse();

  const scrollerRef = useRef(null);

  // Kart yüksekliklerini eşitleyen hook aynı kalabilir
  useEffect(() => {
    const setEqualHeights = () => {
      if (!scrollerRef.current) return;
      const cards = scrollerRef.current.querySelectorAll('.timeline_card');
      if (cards.length === 0) return;
      cards.forEach(card => card.style.height = 'auto');
      let maxHeight = 0;
      cards.forEach(card => {
        if (card.offsetHeight > maxHeight) maxHeight = card.offsetHeight;
      });
      cards.forEach(card => card.style.height = `${maxHeight}px`);
    };

    setEqualHeights();
    window.addEventListener('resize', setEqualHeights);
    return () => window.removeEventListener('resize', setEqualHeights);
  }, [sortedExperienceData]);


  return (
    <section id="qualification">
      <h5>My Journey</h5>
      <h2>Work Experience</h2>

      <div className="qualification_timeline_container">
        <div className="timeline_info">
          <BsBriefcaseFill className="info_icon" />
          <h3>My Career Path</h3>
          <p>
            Here is a timeline of my professional journey, highlighting key roles
            and responsibilities I have undertaken.
          </p>
        </div>

        <ol className="timeline_scroller" ref={scrollerRef}>
          {/* MAP fonksiyonunda artık sıralanmış veriyi kullanıyoruz */}
          {sortedExperienceData.map(val => (
            <li key={val.id}>
              <div className="timeline_card">
                <time>{val.year}</time>
                <h4>{val.title}</h4>
                <h5 className="timeline_company">{val.sortTitle}</h5>
                <p>{val.desc}</p>
              </div>
            </li>
          ))}
          <li aria-hidden="true"></li>
        </ol>
      </div>
    </section>
  );
};

export default Qualification;